import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Box } from '@mui/material'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useProject } from 'contexts/project'
import BaseElegivelExcecoes from './base-elegivel-excecoes'
import MinhaBaseIncluirDadosFaltantes from './minha-base-incluir-dados-faltantes'
import { Adesoes } from './Adesoes'
import { useStyles } from './styles'

interface IRouteParams {
  id: string
  appId: string
  organizationId: string
  contractId: string
  tagId: string
  templateRecipeId: string
}

const ProjectAppsView = () => {
  const { data: project, isLoading, changeProjectId } = useProject()

  const { id, appId, organizationId, contractId, tagId, templateRecipeId } = useParams<IRouteParams>()

  const classes = useStyles()
  const history = useHistory()

  const backToMovimentacoes = ((contractId && tagId) && !templateRecipeId) ? true : false;
  const backToActivities = templateRecipeId ? true : false;

  const handleBackPage = () => {
    history.push(`/projects/${id}/${organizationId}`)
  }

  useEffect(() => {
    if (id) {
      changeProjectId(id)
    }
  }, [id, isLoading])

  if (isLoading) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  const app = project.recipes.find((item) => item.id == appId)

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={app?.appName || ''}
          backRoute={backToMovimentacoes ? `/contract/movimentacao/${organizationId}/${contractId}/${tagId}` : backToActivities ? `/contract/${organizationId}/${contractId}` : `/projects/${id}/${organizationId}/${contractId}`}
        />
      </Header>
      <Page>
        <Box>
          {app?.appName == 'Adesões' && <Adesoes />}
          {app?.appName == 'Exceções' && <BaseElegivelExcecoes />}
          {(app?.appName == 'Incluir Dados Faltantes' || app?.appName == 'Gestão de Dados Faltantes') && (
            <MinhaBaseIncluirDadosFaltantes />
          )}
        </Box>
      </Page>
    </Wrapper>
  )
}

export default ProjectAppsView
